module.exports = __webpack_public_path__ + "static/media/wirtualnemedia.6eaf300c.png";